<template>
  <b-modal
    ref="modal"
    id="ProjectNameDialog"
    title="Project Name"
    @ok="update"
    @show="updateName"
    no-stacking
  >
    <b-row align-v="center" class="mb-3">
      <b-col class="text-right">
        <b-form ref="form">
          <b-input-group :class="{ 'is-invalid': nameState === 'invalid' }">
            <b-input
              v-model="projectName"
              ref="inputName"
              type="text"
              @keyup="checkFormValidity"
              @blur="checkFormValidity"
              required
            ></b-input>
            <b-input-group-append>
              <multiselect
                v-model="fileTypeSelected"
                :multiple="false"
                :options="fileTypes"
                :show-labels="false"
                :show-pointer="false"
              ></multiselect>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <div slot="modal-footer" class="w-100">
      <b-row>
        <b-col>
          <b-button block variant="secondary" @click="closeDialog">
            Cancel
          </b-button>
        </b-col>
        <b-col>
          <b-button block variant="primary" @click="update">
            Update
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "ProjectNameDialog",
  props: {
    name: String
  },
  data() {
    return {
      nameState: "valid",
      projectName: this.name,
      fileTypes: ["jpeg", "png", "svg"],
      fileTypeSelected: "jpeg"
    };
  },
  methods: {
    openDialog() {
      this.$refs.modal.show();
    },
    closeDialog() {
      this.$refs.modal.hide();
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid ? "valid" : "invalid";
      return valid;
    },
    update() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }

      this.$emit("update", {
        projectName: this.projectName,
        projectFileType: this.fileTypeSelected
      });
      this.closeDialog();
    },
    updateName() {
      this.projectName = this.name;
    }
  },
  components: {
    Multiselect
  }
};
</script>

<style lang="scss">
.is-invalid {
  .form-control,
  .multiselect__tags {
    border-color: #e63757;
  }
}
</style>
